var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'u-scroll-fix': (_vm.menuOpen && _vm.isMobile) || _vm.modalOpen },attrs:{"id":"app"}},[_c('navigation'),_c('div',{staticClass:"loader",class:{ on: _vm.loading, off: !_vm.loading }}),_c('router-view'),(_vm.showFooter && !_vm.loading)?_c('CmFooter',{ref:'footer'}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }